import { useEffect, useState } from 'react';
import { Grid, Button, Typography, TextField, Autocomplete, FormHelperText } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import useCustomTranslation from 'hooks/useCustomTranslation';
import List from 'components/List';
import AlertDialog from 'AlertDialog';
import PriceFormDialog from 'components/PriceFormDialog';

function Admin() {
  const { getToken } = useAuth();
  const [prices, setPrices] = useState([])

  const [newPrice, setnewPrice] = useState(null);
  const [newPricesMerged, setNewPricesMerged] = useState([]);
  const [removedPrice, setRemovedPrice] = useState(null);
  const [editablePrice, setEditablePrice] = useState(null);

  const [loading, setLoading] = useState(false);
  const { t } = useCustomTranslation();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');

  const [formOpen, setFormOpen] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const [error, setError] = useState("");

  async function fetchPrices() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/price`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'GET',
        headers
      });
      if (response.ok) {
        const data = await response.json();
        setPrices(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function addPrices() {
    console.log(newPrice)
    //if newPrice is empty
    if (!newPrice) {
      return;
    }

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/price`;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({ price: newPrice }),
      });

      if (response.ok) {
        setnewPrice(''); // Clear input on success
        fetchPrices(); // Refresh prices list
        setError();
      } else {
        console.error('Failed to add price');
        setError(t('Failed to add price.'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function confirmPriceRemove() {
    setDialogContent(t('Are you sure you want to remove this price?'));
    setDialogTitle(t('Remove Price'));
    setDialogOpen(true);
  }

  const handleConfirm = async () => {
    removePrice()
  }

  const editPrice = async () => {
    setFormOpen(true);
    setFormError('');
    setFormSuccess('');
  }


  async function handleEdit(newPrice) {
    console.log(editablePrice)
    console.log(newPrice)
    //if newActivity is empty
    // if (!newActivity) {
    //   return;
    // }

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/price/` + editablePrice?.id;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ price: newPrice }),
      });

      if (response.ok) {
        setEditablePrice(null)
        fetchPrices(); // Refresh activities list
        setError();
      } else {
        console.error('Failed to edit an activity');
        setError(t('Failed to edit an activity.'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const removePrice = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/price/` + removedPrice?.id;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'DELETE',
        headers,
        body: JSON.stringify({ textInput: newPrice }),
      });

      if (response.ok) {
        setRemovedPrice(''); // Clear input on success
        //TODO: returns undefined after complete
        fetchPrices(); // Refresh prices list

        setDialogContent('');
        setDialogTitle('');

      } else {
        console.error('Failed to remove prices');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleNewPriceChange = (value) => {
    console.log(value);
    setnewPrice(value);
  };
  const handleMergedPrices = (value) => {
    console.log(value);
    setNewPricesMerged(value);
  };
  const handleRemovedPrice = (value) => {
    console.log(value);
    setRemovedPrice(value);
  };

  useEffect(() => {
    fetchPrices();
  }, []);


  return (
    <div>
      <Grid container spacing={2} mt={5}>
        <Grid item xs={12} md={8} sx={{ margin: 'auto' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6">{t('Add New Prices')}</Typography>
              <Autocomplete
                id="add-price"
                freeSolo
                value={newPrice}
                onChange={(event, newValue) => handleNewPriceChange(newValue)}
                onInputChange={(event, newValue) => handleNewPriceChange(newValue)}
                options={prices}
                getOptionLabel={(option) => {
                  // Handle both cases: option is an object or a string
                  if (typeof option === 'string') {
                    return option;
                  }
                  return option.price || '';
                }}
                renderInput={(params) => <TextField {...params} label={t("Type a price")} />}
              />
              {error && <FormHelperText error>{error}</FormHelperText>}
              <Button
                variant="contained"
                color="primary"
                onClick={addPrices}
                disabled={loading}
                style={{ marginTop: '10px' }}
              >
                {loading ? t('Adding...') : t('Add Price')}
              </Button>

              <Grid mt={5}>
                <Typography variant="h6">{t('Remove a price')}</Typography>
                <Autocomplete
                  id="remove-price"
                  value={removedPrice || null}
                  onChange={(event, newValue) => handleRemovedPrice(newValue)}
                  options={prices}
                  getOptionLabel={(option) => option.price}
                  renderInput={(params) => <TextField {...params} label={t("Type a price")} />}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={confirmPriceRemove}
                  disabled={loading}
                  style={{ marginTop: '10px' }}
                >
                  {t('Remove Price')}
                </Button>
              </Grid>

              <Grid mt={5}>
                <Typography variant="h6">{t('Edit a price')}</Typography>
                <Autocomplete
                  id="edit-price"
                  value={editablePrice}
                  onChange={(event, newValue) => setEditablePrice(newValue)}
                  options={prices}
                  getOptionLabel={(option) => option.price}
                  renderInput={(params) => <TextField {...params} label={t("Type a price")} />}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editPrice}
                  disabled={loading}
                  style={{ marginTop: '10px' }}
                >
                  {t('Edit Price')}
                </Button>
              </Grid>
            </Grid>

            {/* Right side: Display existing prices */}
            <Grid item xs={12} md={6} pb={30}>
              <Typography variant="h6">{t('All Prices')}</Typography>
              <List items={prices} />

            </Grid>
          </Grid>
        </Grid>

      </Grid>
      <AlertDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        handleConfirm={handleConfirm}
        title={dialogTitle}
        content={dialogContent}
        localeFormat={t}
      />
      <PriceFormDialog
        formOpen={formOpen}
        setFormOpen={setFormOpen}
        type={'edit'}
        price={editablePrice}
        prices={prices}
        onConfirm={handleEdit}
        formError={formError}
        formSuccess={formSuccess}
      />
    </div>
  );
}

export default Admin;
